import styled from 'styled-components';

export const StyledObjectLight = styled.div`
    .slideCon{
        width: 100%;
        padding: 20px;
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            span{
                color:rgba(255,255,255,0.6);
                font-size: 14px;
            }
            .icon{
                color:rgba(255,255,255,0.6);
                cursor: pointer;
                width: 24px;
                height: 24px;
                text-align: center;
                border-radius: 4px;
                &:hover{
                    background-color: rgba(255,255,255,0.12);
                }
            }
        }
        .slideRange{
            padding-top: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            position: relative;
            .angleMask{
                position: absolute;
                top:28px;
                left:4px;
            }
            input[type="range"] {
                margin: auto;
                -webkit-appearance: none;
                outline: none;
                overflow: hidden;
                height: 40px;
                width: calc(100% - 50px);
                cursor: pointer;
                border-radius: 0;
                background: none;
                &::-webkit-slider-runnable-track {
                    background: rgba(255,255,255,0.12);
                    height: 4px;
                    border-radius: 2px;
                }
                &::-webkit-slider-thumb {
                    margin-top: -6px;
                    -webkit-appearance: none;
                    width: 18px;
                    height: 16px;
                    background: #fff;
                    box-shadow:-5px 0 0 -6px #F381B1,-7px 0 0 -6px #F381B1,-9px 0 0 -6px #F381B1, -11px 0 0 -6px #F381B1, -13px 0 0 -6px #F381B1,
    -15px 0 0 -6px #F381B1, -17px 0 0 -6px #F381B1, -19px 0 0 -6px #F381B1, -21px 0 0 -6px #F381B1, -23px 0 0 -6px #F381B1, -25px 0 0 -6px #F381B1, -27px 0 0 -6px #F381B1, -29px 0 0 -6px #F381B1, -31px 0 0 -6px #F381B1, -33px 0 0 -6px #F381B1, -35px 0 0 -6px #F381B1, -37px 0 0 -6px #F381B1, -39px 0 0 -6px #F381B1, -41px 0 0 -6px #F381B1, -43px 0 0 -6px #F381B1, -45px 0 0 -6px #F381B1, -47px 0 0 -6px #F381B1, -49px 0 0 -6px #F381B1, -51px 0 0 -6px #F381B1, -53px 0 0 -6px #F381B1, -55px 0 0 -6px #F381B1, -57px 0 0 -6px #F381B1, -59px 0 0 -6px #F381B1, -61px 0 0 -6px #F381B1, -63px 0 0 -6px #F381B1, -65px 0 0 -6px #F381B1, -67px 0 0 -6px #F381B1, -69px 0 0 -6px #F381B1, -71px 0 0 -6px #F381B1, -73px 0 0 -6px #F381B1, -75px 0 0 -6px #F381B1, -77px 0 0 -6px #F381B1, -79px 0 0 -6px #F381B1, -81px 0 0 -6px #F381B1, -83px 0 0 -6px #F381B1, -85px 0 0 -6px #F381B1, -87px 0 0 -6px #F381B1, -89px 0 0 -6px #F381B1, -91px 0 0 -6px #F381B1, -93px 0 0 -6px #F381B1, -95px 0 0 -6px #F381B1, -97px 0 0 -6px #F381B1, -99px 0 0 -6px #F381B1, -101px 0 0 -6px #F381B1, -103px 0 0 -6px #F381B1, -103px 0 0 -6px #F381B1, -105px 0 0 -6px #F381B1, -107px 0 0 -6px #F381B1, -109px 0 0 -6px #F381B1, -111px 0 0 -6px #F381B1, -113px 0 0 -6px #F381B1, -115px 0 0 -6px #F381B1, -117px 0 0 -6px #F381B1, -119px 0 0 -6px #F381B1, -121px 0 0 -6px #F381B1, -123px 0 0 -6px #F381B1, -125px 0 0 -6px #F381B1, -127px 0 0 -6px #F381B1, -129px 0 0 -6px #F381B1, -131px 0 0 -6px #F381B1, -133px 0 0 -6px #F381B1, -135px 0 0 -6px #F381B1, -137px 0 0 -6px #F381B1, -139px 0 0 -6px #F381B1, -141px 0 0 -6px #F381B1, -143px 0 0 -6px #F381B1, -145px 0 0 -6px #F381B1, -147px 0 0 -6px #F381B1, -149px 0 0 -6px #F381B1, -151px 0 0 -6px #F381B1, -153px 0 0 -6px #F381B1, -155px 0 0 -6px #F381B1, -157px 0 0 -6px #F381B1, -159px 0 0 -6px #F381B1, -161px 0 0 -6px #F381B1, -163px 0 0 -6px #F381B1, -165px 0 0 -6px #F381B1, -167px 0 0 -6px #F381B1, -169px 0 0 -6px #F381B1, -171px 0 0 -6px #F381B1, -173px 0 0 -6px #F381B1, -175px 0 0 -6px #F381B1, -177px 0 0 -6px #F381B1, -179px 0 0 -6px #F381B1;
                    border-radius: 50%;
                }
            }
            .rangeNum{
                width: 40px;
                height: 24px;
                line-height: 24px;
                font-size:14px;
                text-align:center;
                color:#fff;
                border-radius: 3px;
                background-color: rgba(255,255,255,0.12);
            }
        }
    }
`;